import { http } from '@/store/api/http-common.js';

const createSupply = async (payload) => {
	try {
		const { data } = await http.post('supply', payload);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const listSupply = async (params) => {
	try {
		const { data } = await http.get('supply', { params });
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const getSupply = async (id) => {
	try {
		const { data } = await http.get(`supply/${id}`);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const updateSupply = async (id, payload) => {
	try {
		const { data } = await http.put(`supply/${id}`, payload);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const deleteSupply = async (id) => {
	try {
		const { data } = await http.delete(`supply/${id}`);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const deleteSupplyDocument = async (id) => {
	try {
		const { data } = await http.delete(`supply-document/${id}`);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const createSupplyDocument = async (payload) => {
	try {
		const { data } = await http.post('supply-document', payload);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const searchSupply = async (params) => {
	try {
		const { data } = await http.get('supply/search', { params });
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const updateSupplyDocument = async (id, payload) => {
	try {
		const { data } = await http.put(`supply-document/${id}`, payload);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const getSupplyDetail = async (id) => {
	try {
		const { data } = await http.get(`supply/${id}/detail`);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

export { listSupply, createSupply, getSupply, updateSupply, deleteSupply, createSupplyDocument, updateSupplyDocument, deleteSupplyDocument, searchSupply, getSupplyDetail };
